var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaguesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.006,
    height: 22.992,
    viewBox: "0 0 23.006 22.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3189",
    "data-name": "Group 3189",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M22.286,4.144c0,10.608-5.234,14.351-6.739,15.208V21.2a7.671,7.671,0,0,1,4.321,4.3.675.675,0,0,1-.606.969H10.483v0a.672.672,0,0,1-.632-.9A7.7,7.7,0,0,1,14.2,21.2V19.352c-1.5-.857-6.739-4.6-6.739-15.208a.674.674,0,0,1,.674-.674H21.613a.674.674,0,0,1,.674.674Zm1.276,2.134H25.7a.674.674,0,0,1,.674.674.586.586,0,0,1,0,.079c-.027.72-.441,7.8-6.061,9.564.107-.156.211-.313.31-.471a21.023,21.023,0,0,0,2.942-9.847Zm-19.518,0H6.183a21.023,21.023,0,0,0,2.942,9.847c.1.158.2.314.31.471C3.816,14.827,3.4,7.751,3.375,7.031a.73.73,0,0,1,0-.079.674.674,0,0,1,.674-.674Z",
    transform: "translate(-3.37 -3.47)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaguesIcon);
export default __webpack_public_path__ + "static/media/LeaguesIcon.f2fbdebb297e85a319523939a0b4c258.svg";
export { ForwardRef as ReactComponent };